import HTTP from '@/config/axios-config-erp'

const srvAdmUsuarios = {
    deleteUsers(payload) {
        return HTTP.post(`/wscomun/portalinformes/eliminarUsuario`, payload).then(response => {
            return response
        }).catch(error => {
            return error
        });
    },
    changeUserLanguage(payload) {
        
        return HTTP.post(`/wscomun/portalinformes/cambiaIdioma`, payload).then(response => {
            return response
        }).catch(error => {
            return error
        })
    }

}
export default srvAdmUsuarios


// WEBPACK FOOTER //
// ./src/services/srv-adm-usuarios.js